import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function TrialBanner() {
  const { company } = useAuth();
  if (!company || company.status !== "trial" || company.trial_expired) return null;
  const days = company.trial_days_left ?? 0;
  return (
    <div
      data-testid="trial-banner"
      className="mb-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3"
    >
      <div className="flex items-center gap-2.5 text-amber-800">
        <Clock className="h-4 w-4 flex-shrink-0" />
        <span className="text-sm font-medium" data-testid="trial-days-left">
          {days} {days === 1 ? "day" : "days"} left in your free trial
        </span>
      </div>
      <Link
        to="/subscription"
        data-testid="trial-banner-upgrade"
        className="inline-flex items-center justify-center rounded-lg bg-amber-500 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-amber-600"
      >
        Upgrade now
      </Link>
    </div>
  );
}
